import ClaimListing, { ClaimColumns, ClaimFilters, ClaimStatus } from '../shared/ClaimListing/ClaimListing';

export default function DocusignReceivedTab() {
  return (
    <ClaimListing
      columns={[
        ClaimColumns.insuredName,
        ClaimColumns.reinsuranceYear,
        ClaimColumns.policyNumber,
        ClaimColumns.sce,
        ClaimColumns.state,
        ClaimColumns.effectiveDate,
        ClaimColumns.endDate,
        ClaimColumns.claimNumber,
      ]}
      filters={[ClaimFilters.insuredNameSearch]}
      additionalPayload={{ status: ClaimStatus.DocusignInProcess }}
      linkSharedClaimNumber
      includeExport={false}
    />
  );
}
